import { createContext, useContext, useState } from "react";
import { DEFAULT_FY, FY_LIST, getSnapshot } from "../data/ybf/fySnapshots";

const FYContext = createContext({
  fy: DEFAULT_FY,
  setFy: () => {},
  snapshot: getSnapshot(DEFAULT_FY),
  list: FY_LIST,
});

export function FYProvider({ children }) {
  const [fy, setFy] = useState(DEFAULT_FY);
  const snapshot = getSnapshot(fy);
  return (
    <FYContext.Provider value={{ fy, setFy, snapshot, list: FY_LIST }}>
      {children}
    </FYContext.Provider>
  );
}

export function useFY() {
  return useContext(FYContext);
}
